var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-carousel-slide',{class:_vm.slideClass,attrs:{"name":_vm.name,"img-src":_vm.imgSrc}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }